const en_master_whs_setting = {
    "": "Warehouse Settings",
    add: "Add Warehouse",
    edit: "Edit Warehouse",
    name: "Warehouse Name",

    label: {
        coa_supply: "Inventory COA",
        coa_sales: "Sales COA",
    },

    error: {
        address: "Warehouse address is required",
        email: "Warehouse email is required",
        email_valid: "Invalid warehouse email address",
        name: "Warehouse name is required",
        phone: "Warehouse phone number is required",
        create: "Failed to create warehouse",
        edit: "Failed to update warehouse",
    },

    success: {
        create: "Warehouse created successfully",
        edit: "Warehouse updated successfully",
    }
}

export default en_master_whs_setting;